/** @jsxImportSource @emotion/react */
import { ReactComponent as UnstyledIconArrow } from "./arrow.svg";

interface IconArrowProps extends React.HTMLAttributes<SVGElement> {
  dir?: "ul" | "u" | "ur" | "r" | "dr" | "d" | "dl" | "l";
}
const iconArrowCSS = {
  base: {
    // transition: "transform ease 0.1s",
  },
  ul: { transform: "rotate(180deg)" },
  u: { transform: "rotate(225deg)" },
  ur: { transform: "rotate(270deg)" },
  r: { transform: "rotate(315deg)" },
  dr: { transform: "rotate(0deg)" },
  d: { transform: "rotate(45deg)" },
  dl: { transform: "rotate(90deg)" },
  l: { transform: "rotate(135deg)" },
};
function IconArrow({ dir = "dr", ...props }: IconArrowProps) {
  return (
    <UnstyledIconArrow
      css={[iconArrowCSS.base, iconArrowCSS[dir]]}
      {...props}
    />
  );
}

// Font Icons, see this directory's readme.md for more info on usage
export type { IconArrowProps };
export { IconArrow };

export { ReactComponent as IconAdd } from "./add.svg";
export { ReactComponent as IconBell } from "./bell.svg";
export { ReactComponent as IconCalendar } from "./calendar.svg";
export { ReactComponent as IconApecoin } from "./apecoin.svg";
export { ReactComponent as IconAvalanche } from "./avalanche.svg";
export { ReactComponent as IconBarbell } from "./barbell.svg";
export { ReactComponent as IconBoltBrush } from "./bolt_brush.svg";
export { ReactComponent as IconCardano } from "./cardano.svg";
export { ReactComponent as IconCelo } from "./celo.svg";
export { ReactComponent as IconCheck } from "./check.svg";
export { ReactComponent as IconCheckRounded } from "./check_rounded.svg";
export { ReactComponent as IconChevron } from "./chevron.svg";
export { ReactComponent as IconChevronBold } from "./chevron_bold.svg";
export { ReactComponent as IconClockElapsed } from "./clock-elapsed.svg";
export { ReactComponent as IconClose } from "./close.svg";
export { ReactComponent as IconClouds } from "./clouds.svg";
export { ReactComponent as IconCoinbase } from "./coinbase.svg";
export { ReactComponent as IconComment } from "./comment.svg";
export { ReactComponent as IconDiscord } from "./discord_filled.svg";
export { ReactComponent as IconEthereum } from "./ethereum.svg";
export { ReactComponent as IconError } from "./error.svg";
export { ReactComponent as IconEtherscan } from "./etherscan.svg";
export { ReactComponent as IconLadders } from "./equity_ladders.svg";
export { ReactComponent as IconEyesLookingLeft } from "./eyes_looking_left.svg";
export { ReactComponent as IconFilters } from "./filters.svg";
export { ReactComponent as IconFeaturedCreator } from "./featured-creator.svg";
export { ReactComponent as IconFeaturedProject } from "./featured-project.svg";
export { ReactComponent as IconFoundation } from "./foundation.svg";
export { ReactComponent as IconFlow } from "./flow.svg";
export { ReactComponent as IconHoldingHands } from "./holding_hands.svg";
export { ReactComponent as IconHandsYay } from "./hands-yay.svg";
export { ReactComponent as IconHat } from "./hat.svg";
export { ReactComponent as IconHearts } from "./hearts.svg";
export { ReactComponent as IconInclusivity } from "./inclusion_shapes.svg";
export { ReactComponent as IconInfo } from "./info.svg";
export { ReactComponent as IconImx } from "./imx.svg";
export { ReactComponent as IconInstagram } from "./instagram.svg";
export { ReactComponent as IconKlaytn } from "./klaytn.svg";
export { ReactComponent as IconKusama } from "./kusama.svg";
export { ReactComponent as IconLinkedin } from "./linkedin.svg";
export { ReactComponent as IconMagicEden } from "./magic_eden.svg";
export { ReactComponent as IconMedium } from "./medium.svg";
export { ReactComponent as IconMicrophone } from "./microphone.svg";
export { ReactComponent as IconMenuSecondary } from "./menu_secondary.svg";
export { ReactComponent as IconMenu } from "./menu.svg";
export { ReactComponent as IconMetamask } from "./metamask.svg";
export { ReactComponent as IconOmnichain } from "./omnichain.svg";
export { ReactComponent as IconOpenSea } from "./opensea_filled.svg";
export { ReactComponent as IconPencil } from "./pencil.svg";
export { ReactComponent as IconPolygon } from "./polygon.svg";
export { ReactComponent as IconReactionChefsKiss } from "./reaction_chefs-kiss.svg";
export { ReactComponent as IconReactionMeh } from "./reaction_meh.svg";
export { ReactComponent as IconReactionMehNoBg } from "./reaction_meh_no-bg.svg";
export { ReactComponent as IconReactionMehWhiteBg } from "./reaction_meh_white-bg.svg";
export { ReactComponent as IconReactionMustHug } from "./reaction_must-hug.svg";
export { ReactComponent as IconReactionMustHug2 } from "./reaction_must-hug-2.svg";
export { ReactComponent as IconReactionMustHugNoBg } from "./reaction_must-hug_no-bg.svg";
export { ReactComponent as IconReactionMustHugWhiteBg } from "./reaction_must-hug_white-bg.svg";
export { ReactComponent as IconReactionMindBlowing } from "./reaction_mind-blowing.svg";
export { ReactComponent as IconReactionNah } from "./reaction_nah.svg";
export { ReactComponent as IconReactionNahNoBg } from "./reaction_nah_no-bg.svg";
export { ReactComponent as IconReactionNahWhiteBg } from "./reaction_nah_white-bg.svg";
export { ReactComponent as IconReactionNeedItNow } from "./reaction_need-it-now.svg";
export { ReactComponent as IconReactionObsessed } from "./reaction_obsessed.svg";
export { ReactComponent as IconReactionOutOfThisWorld } from "./reaction_out-of-this-world.svg";
export { ReactComponent as IconReactionTakeMyMoney } from "./reaction_take-my-money.svg";
export { ReactComponent as IconReactionThoughtProvoking } from "./reaction_thought-provoking.svg";
export { ReactComponent as IconReactionYay } from "./reaction_yay.svg";
export { ReactComponent as IconReactionYayNoBg } from "./reaction_yay_no-bg.svg";
export { ReactComponent as IconReactionYayWhiteBg } from "./reaction_yay_white-bg.svg";
export { ReactComponent as IconReddit } from "./reddit.svg";
export { ReactComponent as IconSearch } from "./search.svg";
export { ReactComponent as IconShare } from "./share.svg";
export { ReactComponent as IconSolana } from "./solana.svg";
export { ReactComponent as IconStar } from "./star.svg";
export { ReactComponent as IconTelegram } from "./telegram.svg";
export { ReactComponent as IconTikTok } from "./tiktok.svg";
export { ReactComponent as IconTwitter } from "./twitter_filled.svg";
export { ReactComponent as IconTezos } from "./tezos.svg";
export { ReactComponent as IconWalletConnect } from "./walletconnect.svg";
export { ReactComponent as IconWebsite } from "./website.svg";
export { ReactComponent as IconWorldHug } from "./world_hug.svg";
export { ReactComponent as IconX } from "./x_rounded.svg";
export { ReactComponent as IconYouTube } from "./youtube.svg";
